import { Link } from 'wouter'
import { HugeiconsIcon, HugeiconsIconProps } from '@hugeicons/react'
import { UnavailableIcon } from '@hugeicons/core-solid-rounded'

export function EmptyView({
  Icon = UnavailableIcon,
  text,
  to,
  toText,
  children
}: React.PropsWithChildren<{
  Icon?: HugeiconsIconProps['icon']
  text: string
  to?: string
  toText?: string
}>) {
  return (
    <div className="flex flex-col gap-1 items-center text-text">
      <HugeiconsIcon icon={Icon} />
      <h3 className="text-heading3 text-text">{text}</h3>
      {to && toText && (
        <Link to={to} className="text-info-500 pointer-events-auto">
          {toText}
        </Link>
      )}
      {children}
    </div>
  )
}
